module.exports = __webpack_public_path__ + "static/img/ffsc.ab8e615.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ffsc.jpg
// module id = 6/jJ
// module chunks = 1